import { Weight } from "constants/Constants"

export type DrawingType = 'steelwork' | 'toe' | 'handrail' | 'secondary_casting' | 'flow_control_device' | 'reinforcing' | ''
export type MetadataStatusType = 'PENDING_REVIEW' | 'EDITS_REQUESTED' | 'READY_FOR_APPROVAL' | 'APPROVED' | 'ARCHIVED'

export const APPROVED: MetadataStatusType = 'APPROVED'
export const READY_FOR_APPROVAL: MetadataStatusType = 'READY_FOR_APPROVAL'
export const EDITS_REQUESTED: MetadataStatusType = 'EDITS_REQUESTED'
export const PENDING_REVIEW: MetadataStatusType = 'PENDING_REVIEW'
export const ARCHIVED: MetadataStatusType = `ARCHIVED`


export interface PipeOpening {
    pipeId: string,
    pipeType?: 'CULVERT' | 'CUSTOM' | 'PREDEFINED',
    insideDiameter?: number,
    material?: string,
    outsideDiameter?: number, 
    openingSize?: number,
    invertLevel?: number,
    openingLevel?: number,
    height?: number,
    width?: number
  }
  
  export interface FlowControlDevice {
    id: string,
    size: number,
    type: string,
    manufacturer?: string,
  }
  
  interface AssetInfo {
    assetUrl: string,
    assetFileName: string,
    assetFileExtension: string,
    assetPath: string,
  }
  
  export interface DesignDocumentResponse {
    category: string,
    asset: AssetInfo
  }
  
  export interface MetadataInfo {
    byUserId: string,
    byFullName: string,
    timestamp: string,
    comment?: string
}

  export type ActiveActionType = 'ADD_NEW_PRODUCT_LINE' | 'ADD_EXISTING_PRODUCT_LINE' | 'EDIT_PRODUCT_LINE' | 'UPISSUE_PRODUCT' | 'CHANGE_REQUEST_FOR_PRODUCT' | 'CHANGE_REQUEST_FOR_PRODUCT_REQUIRING_UPISSUE'

  export const ADD_NEW_PRODUCT_LINE: ActiveActionType = 'ADD_NEW_PRODUCT_LINE'
  export const UPISSUE_PRODUCT: ActiveActionType = 'UPISSUE_PRODUCT'
  export const EDIT_PRODUCT_LINE: ActiveActionType = 'EDIT_PRODUCT_LINE'

  export interface ActiveAction {
    type: ActiveActionType,
    initiated: MetadataInfo,
    initiatedOnVersion: number,
  }

  export type CreationType = 'EXISTING_PRODUCT_LINE' | 'NEW_PRODUCT_LINE'

  export interface Metadata {
    status: MetadataStatusType,
    version?: number,
    issueNumber?: number,
    upissues?: number[],
    activeAction?: ActiveAction,
    created?: MetadataInfo &{
      creationType?: CreationType,
    },
    lastEdited?: MetadataInfo,  
    lastModerated?: MetadataInfo,
    lastUpissued?: MetadataInfo,
    lastArchived?: MetadataInfo & {
      previousStatus: MetadataStatusType
    }
    lastRestored?: MetadataInfo,
  }

export interface ProductSearchResult {
    objectID: string,
    productCode: string,
    description: string,
    flowControlDevices: FlowControlDevice[],
    secondaryCasting: string[],
    reinforcing: string[],
    productType: string,
    toe: string,
    steelworkCode: string[],
    handrail: string,
    pipeOpenings: PipeOpening[],
    designDocuments: DesignDocumentResponse[],
    tags: string[],
    weight?: number,
    legacyProductCode: string,
    metadata?: Metadata
  }

export type DrawingSearchResult = {
  objectID: string,
  code: string,
  drawingCode?: string,
  description: string,
  type: DrawingType,
  weight: number,
  tags: string[],
  designDocuments: DesignDocumentResponse[],
  metadata?: Metadata
}